import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

let redux = reduxCreator.type('ROOM').plugin(axiosPlugin);

let fetchRoomAction = redux.fetchActionGetOne();

let createRoomAction = redux.fetchActionCreate();
let leaveAction = redux.fetchActionCreate('LEAVE');

let lockAction = redux.fetchActionUpdate('LOCK');

let updateRoomAction = redux.fetchActionUpdate();

let deleteRoomMessageAction = redux.fetchActionDelete();

export const TYPES = redux.types;

export const fetchRoom = (roomId, query = {}) => fetchRoomAction(`/rooms/${roomId}?${queryString.stringify(query)}`);
export const createRoom = (data = {}) => createRoomAction(`/rooms`, data);
export const updateRoom = (roomId, data = {}) => updateRoomAction(`/rooms/${roomId}`, data);
export const joinRoom = (roomId, joinRoom = {}) => createRoomAction(`/rooms/${roomId}/join-member`, joinRoom);
export const leaveRoom = (roomId, leaveRoom = {}) => leaveAction(`/rooms/${roomId}/leave-member`, leaveRoom);
export const lockRoom = (roomId, lockRoom = {}) => lockAction(`/rooms/${roomId}/lock-room`, lockRoom);
export const readRoom = (roomId, readRoom = {}) => updateRoomAction(`/rooms/${roomId}/read-room`, readRoom);
export const archivedRoom = (roomId, archivedRoom = {}) => updateRoomAction(`/rooms/${roomId}/archived-room`, archivedRoom);
export const removeRoomByUser = (roomId) => deleteRoomMessageAction(`/rooms/${roomId}`);
export const resetRoom = () => redux.actions.reset();

export const room = redux.reducer();